export default __webpack_public_path__ + "static/media/defient_image1.png.webp";